import { Typography } from 'antd'
import {
  CustomMenuItemType,
  NO_NAVIGATE_KEY,
} from '../../e-office-layout/components/dynamic-menu/custom-menu-items-type'
import IconGlobalApp from '../../../utils/IconGlobalApp'
import { E_OFFICE_PREFIX_URL } from '../../e-office-layout/constants/config.e-office-layout'
import { DOCUMENT_SHORT_PREFIX_URL } from './config.document'
import { DOCUMENT_INCOMING_PREFIX_URL } from '../modules/document-incoming/constants/config.document-incoming'
import { DOCUMENT_CATEGORY_PREFIX_URL } from '../modules/document-category/constants/config.document-category'
import { DOCUMENT_OUTGOING_PREFIX_URL } from '../modules/document-outgoing/constants/config.document-outgoing'

/*!
 * Copyright (c) HoaDev and contributors. All rights reserved.
 * More licensed under license file.
 * Created by HoaDev, 10/06/2022
 */

const baseUrl = `${E_OFFICE_PREFIX_URL}${DOCUMENT_SHORT_PREFIX_URL}`

export const LIST_MENU_DOCUMENT: CustomMenuItemType<'submenu'> = {
  key: `${NO_NAVIGATE_KEY}-${DOCUMENT_SHORT_PREFIX_URL}`,
  icon: <IconGlobalApp name="file-archive" />,
  label: (
    <Typography.Link strong ellipsis title="Văn thư">
      Văn thư
    </Typography.Link>
  ),
  children: [
    {
      key: `${NO_NAVIGATE_KEY}-${DOCUMENT_OUTGOING_PREFIX_URL}`,
      label: 'Văn thư đi',
      icon: <IconGlobalApp name="file-output" />,
      children: [
        {
          key: `${baseUrl}${DOCUMENT_OUTGOING_PREFIX_URL}/report`,
          label: 'Báo cáo',
        },
        {
          key: `${baseUrl}${DOCUMENT_OUTGOING_PREFIX_URL}/all`,
          label: 'Tất cả',
        },
        {
          key: `${baseUrl}${DOCUMENT_OUTGOING_PREFIX_URL}/my-created`,
          label: 'Tôi tạo',
        },
        {
          key: `${baseUrl}${DOCUMENT_OUTGOING_PREFIX_URL}/my-process`,
          label: 'Tôi xử lý',
        },
        {
          key: `${baseUrl}${DOCUMENT_OUTGOING_PREFIX_URL}/waiting-approval`,
          label: 'Chờ tôi duyệt',
        },
      ],
    },
    {
      key: `${NO_NAVIGATE_KEY}-${DOCUMENT_INCOMING_PREFIX_URL}`,
      label: 'Văn thư đến',
      icon: <IconGlobalApp name="file-input" />,
      children: [
        {
          key: `${baseUrl}${DOCUMENT_INCOMING_PREFIX_URL}/report`,
          label: 'Báo cáo',
        },
        {
          key: `${baseUrl}${DOCUMENT_INCOMING_PREFIX_URL}/all`,
          label: 'Tất cả',
        },
        {
          key: `${baseUrl}${DOCUMENT_INCOMING_PREFIX_URL}/my-created`,
          label: 'Tôi tạo',
        },
        {
          key: `${baseUrl}${DOCUMENT_INCOMING_PREFIX_URL}/my-process`,
          label: 'Tôi xử lý',
        },
        {
          key: `${baseUrl}${DOCUMENT_INCOMING_PREFIX_URL}/waiting-approval`,
          label: 'Chờ tôi duyệt',
        },
      ],
    },
    {
      key: `${baseUrl}${DOCUMENT_CATEGORY_PREFIX_URL}`,
      label: 'Loại tài liệu',
    },
  ],
}
